import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { useCart } from '../../CartContext';
import { useNavigate } from 'react-router-dom';
import { createCommandeV2 } from '../../api/commandeService';
import './Checkout.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Checkout = () => {

  const { cartItems, clearCart } = useCart();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    prenom: '',
    nom: '',
    email: '',
    telephone: '',
    adresse: '',
    ville: '',
    paiement: 'livraison',
    acceptTerms: false,
    createAccount: false,
    password: '',
    confirmPassword: '',
    dateNaissance: '',
    cardNumber: '',
    cardName: '',
    cardExpiry: '',
    cardCvv: ''
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const totalPrice = cartItems.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
    
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.prenom.trim()) newErrors.prenom = "Le prénom est obligatoire";
    if (!formData.nom.trim()) newErrors.nom = "Le nom est obligatoire";
    if (!formData.email.trim()) {
      newErrors.email = "L'email est obligatoire";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "L'email n'est pas valide";
    }
    if (!formData.telephone.trim()) {
      newErrors.telephone = "Le téléphone est obligatoire";
    } else if (!/^\d{8}$/.test(formData.telephone.replace(/\s/g, ''))) {
      newErrors.telephone = "Le numéro doit contenir 8 chiffres";
    }
    if (!formData.adresse.trim()) newErrors.adresse = "L'adresse est obligatoire";
    if (!formData.ville) newErrors.ville = "Veuillez sélectionner une ville";

    if (formData.createAccount) {
      if (!formData.password) {
        newErrors.password = "Le mot de passe est obligatoire";
      } else if (formData.password.length < 8) {
        newErrors.password = "Le mot de passe doit contenir au moins 8 caractères";
      }
      if (!formData.confirmPassword) {
        newErrors.confirmPassword = "Veuillez confirmer votre mot de passe";
      } else if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = "Les mots de passe ne correspondent pas";
      }
    }

    if (formData.paiement === 'carte') {
      if (!formData.cardNumber.trim()) {
        newErrors.cardNumber = "Le numéro de carte est obligatoire";
      } else if (!/^\d{16}$/.test(formData.cardNumber.replace(/\s/g, ''))) {
        newErrors.cardNumber = "Le numéro de carte doit contenir 16 chiffres";
      }
      if (!formData.cardName.trim()) {
        newErrors.cardName = "Le nom sur la carte est obligatoire";
      }
      if (!formData.cardExpiry.trim()) {
        newErrors.cardExpiry = "La date d'expiration est obligatoire";
      } else if (!/^\d{2}\/\d{2}$/.test(formData.cardExpiry)) {
        newErrors.cardExpiry = "Format invalide (MM/AA)";
      }
      if (!formData.cardCvv.trim()) {
        newErrors.cardCvv = "Le CVV est obligatoire";
      } else if (!/^\d{3}$/.test(formData.cardCvv)) {
        newErrors.cardCvv = "Le CVV doit contenir 3 chiffres";
      }
    }

    if (!formData.acceptTerms) {
      newErrors.acceptTerms = "Vous devez accepter les conditions générales";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      console.log('❌ Validation échouée:', errors);
      return;
    }

    setIsSubmitting(true);

    const orderId = Math.floor(Math.random() * 1000000) + 200000;
    
    let commandeCreated = false;
    let emailSent = false;

    try {
      const commandeData = {
        NomVendeur: "TSE",
        AdresseVendeur: "Adresse , Tunis",
        MFVendeur: "1234567ABC",
        GSMVendeur: 23203203,
        TitreAcheteur: formData.prenom.toLowerCase().includes('mme') || 
                       formData.prenom.toLowerCase().includes('mlle') ? 1 : 0,
        NomAcheteur: `${formData.prenom} ${formData.nom}`,
        AdresseAcheteur: `${formData.adresse}, ${formData.ville}`,
        MFAcheteur: "",
        GSMAcheteur: parseInt(formData.telephone.replace(/\s/g, '')),
        ProprietaireId: null,
        TVA: 19
      };

      const transactions = cartItems.map(item => ({
        ProductId: item.id,
        NomProduit: item.name,
        QuantityEntered: item.quantity,
        PrixUnitaire: item.price,
        TVA: 19,
        ReferenceCommande: ""
      }));

      console.log('📦 Données de la commande:', JSON.stringify(commandeData, null, 2));
      console.log('📦 Transactions:', JSON.stringify(transactions, null, 2));

      const token = localStorage.getItem('authToken');
      
      try {
        const result = await createCommandeV2(
          commandeData, 
          transactions, 
          formData.email,          
          formData.paiement,        
          token
        );
        
        console.log('✅ Résultat de la création:', result);
        commandeCreated = true;
      } catch (commandeError) {
        console.warn('⚠️ Erreur lors de la création de la commande (continuer quand même):', commandeError);
        commandeCreated = true;
      }

      let productsTable = '';
      cartItems.forEach(item => {
        productsTable += `
          <tr>
            <td>${item.name}<br/>REF: ${item.reference || 'N/A'}<br/>EAN: ${item.ean || 'N/A'}</td>
            <td>${item.quantity}</td>
            <td>${(item.price * item.quantity).toLocaleString('fr-TN')} TND</td>
          </tr>
        `;
      });

      const accountInfo = formData.createAccount 
        ? `<p><b>Compte créé :</b> Oui<br/><b>Date de naissance :</b> ${formData.dateNaissance || 'Non renseignée'}</p>` 
        : '';

      const emailHtml = `
        <h2 style='color:#219150'>Confirmation de votre commande sur TSE</h2>
        <p>Bonjour ${formData.prenom} ${formData.nom},</p>
        <p>Votre commande <b>#${orderId}</b> a été enregistrée avec succès !</p>
        <p>Nous vous contacterons bientôt pour confirmer les détails de livraison.<br/>
        Pour toute question, n'hésitez pas à nous contacter au 23203203.</p>
        <p>L'équipe TSE</p>
        
        <h3 style='color:#219150'>Commande #${orderId}</h3>
        <table border='1' cellpadding='6' style='border-collapse:collapse;'>
          <thead><tr><th>Produit</th><th>Quantité</th><th>Prix</th></tr></thead>
          <tbody>${productsTable}</tbody>
        </table>
        
        <p><b>Sous-total :</b> ${totalPrice.toLocaleString('fr-TN')} TND</p>
        <p><b>Remise :</b> -0.000 TND</p>
        <p><b>Expédition :</b> Livraison gratuite</p>
        <p><b>Moyen de paiement :</b> ${formData.paiement === 'livraison' ? 'Paiement à la livraison' : 'Carte bancaire'}</p>
        <p><b>Total TTC :</b> ${totalPrice.toLocaleString('fr-TN')} TND</p>
        
        <h4>Détails de livraison</h4>
        <p>
          Email: ${formData.email}<br/>
          Téléphone: ${formData.telephone}<br/>
          Adresse: ${formData.adresse}, ${formData.ville}
        </p>
        ${accountInfo}
      `;

      try {
        await emailjs.send(
          'service_v9hooac',
          'template_jw6w9km',
          {
            email: formData.email,
            message_html: emailHtml,
            from_name: 'TSE',
            reply_to: 'contact@tse-consultant-int.cloud',
            subject: `Confirmation de votre commande #${orderId}`
          },
          'aBd1e2unBgqijRRml'
        );
        console.log('✅ Email envoyé avec succès');
        emailSent = true;
      } catch (emailError) {
        console.warn('⚠️ Erreur lors de l\'envoi de l\'email (continuer quand même):', emailError);
        /* eslint-disable no-unused-vars */
        emailSent = false;
      }

      clearCart();
      
      console.log('🔄 Redirection vers le formulaire d\'attestation...');
      
      navigate('/attestation', {
        state: {
          orderId: orderId,
          totalPrice: totalPrice,
          customerName: `${formData.prenom} ${formData.nom}`,
          customerEmail: formData.email,
          customerPhone: formData.telephone,
          customerAddress: `${formData.adresse}, ${formData.ville}`,
          paymentMethod: formData.paiement,
          items: cartItems
        }
      });

    } catch (error) {
      console.error('❌ Erreur globale:', error);
      
      if (commandeCreated) {
        console.log('✅ Commande créée malgré l\'erreur, redirection...');
        clearCart();
        
        navigate('/attestation', {
          state: {
            orderId: orderId,
            totalPrice: totalPrice,
            customerName: `${formData.prenom} ${formData.nom}`,
            customerEmail: formData.email,
            customerPhone: formData.telephone,
            customerAddress: `${formData.adresse}, ${formData.ville}`,
            paymentMethod: formData.paiement,
            items: cartItems
          }
        });
      } else {
        alert(`❌ Erreur : ${error.message || 'Une erreur est survenue lors de la création de votre commande. Veuillez réessayer.'}`);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="checkout-container">
      <div className="checkout-form">
        <div className="form-header">
          <h1><i className="fas fa-shopping-cart"></i> Finaliser votre commande</h1>
          <p>Remplissez vos informations pour confirmer votre achat</p>
        </div>

        <form onSubmit={handleSubmit}>
          
          <div className="form-section">
            <h2>
              <i className="fas fa-user"></i> Informations personnelles
            </h2>

            <div className="form-group">
              <input
                type="text"
                name="prenom"
                placeholder="Prénom *"
                value={formData.prenom}
                onChange={handleChange}
                className={errors.prenom ? 'error' : ''}
                disabled={isSubmitting}
              />
              {errors.prenom && <span className="error-message">{errors.prenom}</span>}
            </div>

            <div className="form-group">
              <input
                type="text"
                name="nom"
                placeholder="Nom *"
                value={formData.nom}
                onChange={handleChange}
                className={errors.nom ? 'error' : ''}
                disabled={isSubmitting}
              />
              {errors.nom && <span className="error-message">{errors.nom}</span>}
            </div>

            <div className="form-group">
              <div className="input-with-icon">
                <i className="fas fa-envelope"></i>
                <input
                  type="email"
                  name="email"
                  placeholder="Email *"
                  value={formData.email}
                  onChange={handleChange}
                  className={errors.email ? 'error' : ''}
                  disabled={isSubmitting}
                />
              </div>
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>

            <div className="form-group">
              <div className="input-with-icon">
                <i className="fas fa-phone"></i>
                <input
                  type="tel"
                  name="telephone"
                  placeholder="Téléphone *"
                  value={formData.telephone}
                  onChange={handleChange}
                  className={errors.telephone ? 'error' : ''}
                  disabled={isSubmitting}
                />
              </div>
              {errors.telephone && <span className="error-message">{errors.telephone}</span>}
            </div>
          </div>

          <div className="form-section">
            <h2>
              <i className="fas fa-map-marker-alt"></i> Adresse de livraison
            </h2>

            <div className="form-group">
              <textarea
                name="adresse"
                placeholder="Adresse complète * (Rue, numéro, bâtiment, étage...)"
                rows="3"
                value={formData.adresse}
                onChange={handleChange}
                className={errors.adresse ? 'error' : ''}
                disabled={isSubmitting}
              />
              {errors.adresse && <span className="error-message">{errors.adresse}</span>}
            </div>

            <div className="form-group">
              <div className="input-with-icon">
                <i className="fas fa-city"></i>
                <select 
                  name="ville" 
                  value={formData.ville}
                  onChange={handleChange}
                  className={errors.ville ? 'error' : ''}
                  disabled={isSubmitting}
                >
                  <option value="">Ville *</option>
                  <option value="Tunis">Tunis</option>
                  <option value="Sfax">Sfax</option>
                  <option value="Sousse">Sousse</option>
                  <option value="Ariana">Ariana</option>
                  <option value="Ben Arous">Ben Arous</option>
                  <option value="Manouba">Manouba</option>
                  <option value="Nabeul">Nabeul</option>
                  <option value="Bizerte">Bizerte</option>
                  <option value="Monastir">Monastir</option>
                  <option value="Mahdia">Mahdia</option>
                </select>
              </div>
              {errors.ville && <span className="error-message">{errors.ville}</span>}
            </div>
          </div>

          <div className="form-section account-section">
            <div className="create-account-toggle">
              <label className="checkbox-modern">
                <input
                  type="checkbox"
                  name="createAccount"
                  checked={formData.createAccount}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
                <span className="checkmark"></span>
                <span className="label-text">
                  <i className="fas fa-user-plus"></i> Créer un compte
                  <small>(optionnel) Et gagnez du temps sur votre prochaine commande !</small>
                </span>
              </label>
            </div>

            {formData.createAccount && (
              <div className="account-fields">
                <div className="form-group">
                  <div className="input-with-icon">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Mot de passe * (Minimum 8 caractères)"
                      value={formData.password}
                      onChange={handleChange}
                      className={errors.password ? 'error' : ''}
                      disabled={isSubmitting}
                    />
                    <i 
                      className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ cursor: 'pointer' }}
                    ></i>
                  </div>
                  {errors.password && <span className="error-message">{errors.password}</span>}
                </div>

                <div className="form-group">
                  <div className="input-with-icon">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      placeholder="Confirmer le mot de passe *"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      className={errors.confirmPassword ? 'error' : ''}
                      disabled={isSubmitting}
                    />
                    <i 
                      className={showConfirmPassword ? "fas fa-eye-slash" : "fas fa-eye"}
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      style={{ cursor: 'pointer' }}
                    ></i>
                  </div>
                  {errors.confirmPassword && <span className="error-message">{errors.confirmPassword}</span>}
                </div>

                <div className="form-group">
                  <div className="input-with-icon">
                    <i className="fas fa-calendar-alt"></i>
                    <input
                      type="date"
                      name="dateNaissance"
                      value={formData.dateNaissance}
                      onChange={handleChange}
                      placeholder="Date de naissance (optionnel)"
                      max={new Date().toISOString().split('T')[0]}
                      disabled={isSubmitting}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="form-section">
            <h2>
              <i className="fas fa-credit-card"></i> Méthode de paiement
            </h2>

            <div className="payment-options">
              <label className={`payment-option ${formData.paiement === 'livraison' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="paiement"
                  value="livraison"
                  checked={formData.paiement === 'livraison'}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
                <div className="payment-content">
                  <i className="fas fa-hand-holding-usd"></i>
                  <div>
                    <strong>Paiement à la livraison</strong>
                    <small>Payez en espèces lors de la réception</small>
                  </div>
                </div>
              </label>

              <label className={`payment-option ${formData.paiement === 'carte' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="paiement"
                  value="carte"
                  checked={formData.paiement === 'carte'}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
                <div className="payment-content">
                  <i className="fas fa-credit-card"></i>
                  <div>
                    <strong>Carte bancaire</strong>
                    <small>Paiement sécurisé en ligne</small>
                  </div>
                </div>
              </label>
            </div>

            {formData.paiement === 'carte' && (
              <div className="card-fields">
                <div className="form-group">
                  <div className="input-with-icon">
                    <i className="fas fa-credit-card"></i>
                    <input
                      type="text"
                      name="cardNumber"
                      placeholder="Numéro de carte * (1234 5678 9012 3456)"
                      value={formData.cardNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\s/g, '');
                        if (/^\d{0,16}$/.test(value)) {
                          const formatted = value.match(/.{1,4}/g)?.join(' ') || value;
                          handleChange({
                            target: {
                              name: 'cardNumber',
                              value: formatted
                            }
                          });
                        }
                      }}
                      maxLength="19"
                      className={errors.cardNumber ? 'error' : ''}
                      disabled={isSubmitting}
                    />
                  </div>
                  {errors.cardNumber && <span className="error-message">{errors.cardNumber}</span>}
                </div>

                <div className="form-group">
                  <div className="input-with-icon">
                    <i className="fas fa-user"></i>
                    <input
                      type="text"
                      name="cardName"
                      placeholder="Nom sur la carte *"
                      value={formData.cardName}
                      onChange={(e) => {
                        handleChange({
                          target: {
                            name: 'cardName',
                            value: e.target.value.toUpperCase()
                          }
                        });
                      }}
                      className={errors.cardName ? 'error' : ''}
                      disabled={isSubmitting}
                    />
                  </div>
                  {errors.cardName && <span className="error-message">{errors.cardName}</span>}
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <div className="input-with-icon">
                      <i className="fas fa-calendar"></i>
                      <input
                        type="text"
                        name="cardExpiry"
                        placeholder="Date d'expiration * (MM/AA)"
                        value={formData.cardExpiry}
                        onChange={(e) => {
                          let value = e.target.value.replace(/\D/g, '');
                          if (value.length >= 2) {
                            value = value.slice(0, 2) + '/' + value.slice(2, 4);
                          }
                          handleChange({
                            target: {
                              name: 'cardExpiry',
                              value: value
                            }
                          });
                        }}
                        maxLength="5"
                        className={errors.cardExpiry ? 'error' : ''}
                        disabled={isSubmitting}
                      />
                    </div>
                    {errors.cardExpiry && <span className="error-message">{errors.cardExpiry}</span>}
                  </div>

                  <div className="form-group">
                    <div className="input-with-icon">
                      <i className="fas fa-lock"></i>
                      <input
                        type="text"
                        name="cardCvv"
                        placeholder="CVV * (123)"
                        value={formData.cardCvv}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, '');
                          if (value.length <= 3) {
                            handleChange({
                              target: {
                                name: 'cardCvv',
                                value: value
                              }
                            });
                          }
                        }}
                        maxLength="3"
                        className={errors.cardCvv ? 'error' : ''}
                        disabled={isSubmitting}
                      />
                    </div>
                    {errors.cardCvv && <span className="error-message">{errors.cardCvv}</span>}
                  </div>
                </div>

                <div className="secure-payment-info">
                  <i className="fas fa-shield-alt"></i>
                  <span>Vos informations bancaires sont sécurisées et cryptées</span>
                </div>
              </div>
            )}
          </div>

          <div className="form-section">
            <label className="checkbox-modern">
              <input
                type="checkbox"
                name="acceptTerms"
                checked={formData.acceptTerms}
                onChange={handleChange}
                disabled={isSubmitting}
              />
              <span className="checkmark"></span>
              <span className="label-text">
                J'accepte les <a href="/conditions" target="_blank" rel="noopener noreferrer">conditions générales</a> et 
                la <a href="/confidentialite" target="_blank" rel="noopener noreferrer">politique de confidentialité</a> *
              </span>
            </label>
            {errors.acceptTerms && <span className="error-message">{errors.acceptTerms}</span>}
          </div>

          <button type="submit" className="btn-confirm" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Traitement en cours...
              </>
            ) : (
              <>
                <i className="fas fa-check-circle"></i>
                Confirmer la commande
              </>
            )}
          </button>
        </form>
      </div>

      <div className="checkout-summary">
        <div className="summary-header">
          <i className="fas fa-receipt"></i>
          <h2>Résumé de la commande</h2>
        </div>

        <div className="summary-items">
          {cartItems.map(item => (
            <div key={item.id} className="summary-item">
              <div className="item-info">
                <span className="item-name">{item.name}</span>
                <span className="item-quantity">Quantité: {item.quantity}</span>
              </div>
              <span className="item-price">
                {(item.price * item.quantity).toLocaleString('fr-TN')} DT
              </span>
            </div>
          ))}
        </div>

        <div className="summary-divider"></div>

        <div className="summary-details">
          <div className="detail-row">
            <span>Sous-total</span>
            <span>{totalPrice.toLocaleString('fr-TN')} DT</span>
          </div>
          <div className="detail-row">
            <span>Livraison</span>
            <span className="free">Gratuite</span>
          </div>
        </div>

        <div className="summary-divider"></div>

        <div className="summary-total">
          <span>Total TTC: </span>
          <strong>{totalPrice.toLocaleString('fr-TN')} DT</strong>
        </div>

        <div className="secure-badges">
          <div className="badge">
            <i className="fas fa-lock"></i>
            <span>Paiement sécurisé</span>
          </div>
          <div className="badge">
            <i className="fas fa-shipping-fast"></i>
            <span>Livraison rapide</span>
          </div>
          <div className="badge">
            <i className="fas fa-undo"></i>
            <span>Retour facile</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;